import { isEmpty } from 'lodash';
import { useSnapshot } from 'valtio';
import { EditorMode, ProjectGeometryType } from '~/common/types';
import MultiButton from '~/pages/common/ProjectDataPanel/MultiButton';
import store from './store';

export default function Segments() {
  const { objectsAsArray, currentObject, geometryType } = useSnapshot(store) as typeof store;

  if (geometryType === ProjectGeometryType.Small_3ac || geometryType === ProjectGeometryType.Circle) {
    return null;
  }

  return (
    <div>
      <div className="group mx-2 space-y-1">
        <MultiButton
          label="Add Segment"
          isDisabled={objectsAsArray.length === 25}
          icon="plus"
          color="bg-white"
          onClick={() => {
            store.resetCurrentObjectId();

            if (store.geometryType === ProjectGeometryType.Linear) {
              store.setEditorMode(EditorMode.DrawLine);
            } else if (store.geometryType === ProjectGeometryType.Polygon) {
              store.setEditorMode(EditorMode.DrawPolygon);
            }
          }}
        />

        {!isEmpty(currentObject) && (
          <MultiButton
            label="Delete Segment"
            variant="danger"
            icon="delete"
            onClick={() => {
              store.deleteObject(store.currentObject);
              store.resetCurrentObjectId();
              if (store.objectsAsArray.length === 0) {
                store.setEditorMode(EditorMode.None);
              }
            }}
          />
        )}

        {store.editorMode.startsWith('Draw') && (
          <MultiButton
            label="Discard"
            color="bg-yellow-300"
            isDisabled={objectsAsArray.length === 5}
            icon="close"
            onClick={() => {
              store.setEditorMode(EditorMode.None);
            }}
          />
        )}
      </div>
    </div>
  );
}
